<script>
export default {
  props: {
    to: { type: String, default: '' },
    name: { type: String, default: '' },
    icon: { type: String, default: '' },
    count: { type: String, default: '' },
    isChildMenuActive: { type: Boolean, default: false },
    openInNewPage: { type: Boolean, default: false },
  },
  computed: {
    shortLabel() {
      // Mapping de keys SIDEBAR.* a etiquetas cortas (max 9-10 chars)
      const map = {
        CONVERSATIONS: 'Bandeja',
        PIPELINE: 'Embudo',
        VENTAS: 'Ventas',
        LLAMADAS: 'Llamadas',
        MI_EQUIPO: 'Mi Equipo',
        TAREAS: 'Tareas',
        ENVIO_MASIVO: 'Envío',
        HOME: 'Inicio',
        FLOWS: 'Flujos',
        CANALES: 'Canales',
        AGENTE_IA: 'Agente IA',
        METRICAS: 'Métricas',
        BOTS: 'Bots',
        CONTACTS: 'Contactos',
        CATALOGO: 'Catalogo',
        REPORTS: 'Reportes',
        CAMPAIGNS: 'Campañas',
        HELP_CENTER: 'Helpdesk',
        AGENT_BOTS: 'Bots',
        AUTOMATION: 'Automat.',
        NOTIFICATIONS: 'Notif.',
        SETTINGS: 'Ajustes',
        INTEGRATIONS: 'Integra.',
        TEAMS: 'Equipos',
        AGENTS: 'Agentes',
        INBOXES: 'Inboxes',
        LABELS: 'Etiquetas',
        CANNED_RESPONSES: 'Plantillas',
        SLA: 'SLA',
        AUDIT_LOGS: 'Auditoria',
        CUSTOM_ATTRIBUTES: 'Atributos',
        DOCS: 'Docs',
      };
      return (
        map[this.name] ||
        (this.$t(`SIDEBAR.${this.name}`) || this.name).slice(0, 9)
      );
    },
  },
};
</script>

<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right="$t(`SIDEBAR.${name}`)"
      :href="href"
      class="ci-nav-item w-[54px] py-2 my-1 flex flex-col items-center justify-center rounded-xl relative transition-all hover:bg-white/5 text-white/60 hover:text-white/95"
      :class="{
        'ci-nav-active': isActive || isChildMenuActive,
      }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <fluent-icon :icon="icon" />
      <span
        class="text-[9px] font-semibold mt-1 leading-tight max-w-full truncate px-1"
      >
        {{ shortLabel }}
      </span>
      <span
        v-if="count"
        class="ci-nav-badge absolute top-0.5 right-1 text-[9px] font-bold px-1.5 py-0.5 rounded-full min-w-[16px] text-center leading-tight"
      >
        {{ count }}
      </span>
    </a>
  </router-link>
</template>

<style scoped>
.ci-nav-active {
  background: rgba(0, 240, 192, 0.15) !important;
  color: #00f0c0 !important;
}

.ci-nav-active::before {
  content: '';
  position: absolute;
  left: -13px;
  top: 8px;
  bottom: 8px;
  width: 3px;
  background: #00f0c0;
  border-radius: 0 3px 3px 0;
}

.ci-nav-badge {
  background: #00f0c0;
  color: #000060;
}
</style>
